import React from "react";

/** نمایش تاریخ فارسی — بدون نیاز به date-fns-tz */
const GetTime = ({ time }) => {
  const utcDate = new Date(time).toLocaleDateString("fa-IR");
  return <div>{utcDate}</div>;
};

export default GetTime;
